import ConfirmationModal from 'components/ui/modals/confirmation/ConfirmationModal'
import { useTranslation } from 'react-i18next'

interface DeleteManyCertificatesProps {
  show: boolean
  count: number
  onAccept(): void
  onClose(): void
}

export const DeleteManyCertificates = ({
  show,
  count,
  onAccept,
  onClose,
}: DeleteManyCertificatesProps) => {
  const { t } = useTranslation()
  const key = `administration.modal.externalCoursesCertificatesDeleteConfirmation`
  return (
    <ConfirmationModal
      show={show}
      title=""
      text={t(key, {
        count,
      })}
      acceptButtonText={t('components.modal.buttons.delete')}
      onAccept={() => onAccept()}
      onClose={() => onClose()}
    />
  )
}
